<div class="bg-gray-100 rounded-2xl rounded-tl-md p-5">
    <!-- Member Card Header -->
    <div class="flex items-center gap-4 mb-4">
        <!-- Avatar -->
        <spotlight-avatar
            [data]="data"
            size="lg"
            rounded="xl">
        </spotlight-avatar>

        <!-- Name and Title -->
        <div class="flex-1">
            <h3 class="text-[18px] font-remote font-[600] text-gray-900">{{ getName() }}</h3>
            <p class="text-[13px] font-inter text-gray-500">{{ title }}</p>
        </div>
    </div>

    <!-- Complementary Data -->
    <div *ngIf="getComplementaryFields().length > 0" class="flex flex-wrap gap-3 mb-4">
        <div *ngFor="let field of getComplementaryFields()"
             class="flex-1 min-w-[80px] bg-white bg-opacity-60 rounded-lg p-3 text-center">
            <div class="text-[10px] font-inter text-gray-500 uppercase tracking-wide mb-1">
                {{ field.label }}
            </div>
            <div class="text-[14px] font-remote font-[600] text-gray-800">
                {{ field.formattedValue }}
            </div>
        </div>
    </div>

    <!-- Description -->
    <p class="text-[14px] font-inter text-gray-600 leading-relaxed">
        {{ description }}
    </p>

    <!-- Footer -->
    <spotlight-response-footer
        [executionTimeMs]="executionTimeMs">
    </spotlight-response-footer>
</div>
